import { Box } from '@mui/material'
import { useContext } from 'react'
import { NOT_APPLICABLE } from '../../constants'
import { AppContext } from '../../context'
import { DepartmentMenuProps } from '../../interfaceTypes/props'
import CustomMenu from '../common/CustomMenu'
import { DeleteModalContent } from '../common/DeleteModalContent'
import { useDeleteDepartmentMutation } from '../../../generated'
import { Alert } from '../common/Alert'
import { ActionType } from '../../context/AppContextReducer'
import DepartmentModal from '../departments/DepartmentModal'

// others

const DepartmentMenu = ({ department, refetch }: DepartmentMenuProps) => {
  const { dispatch } = useContext(AppContext)
  
  const { id: departmentId = '', name, description } = department ?? {}
  
  const [deleteDepartment, { loading: deleting }] = useDeleteDepartmentMutation({
    onError: error => {
      Alert.error(`Department couldn't be deleted due to: ${error.message}`)
    },
    onCompleted: () => {
      dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: false })
      Alert.success('Department deleted successfully')
      refetch()
    }
  })
    
  const onDeleteDepartment = async (departmentId: string) => await deleteDepartment({ variables: { deleteDepartmentId: departmentId } })
    
  return (
    <CustomMenu 
      id={departmentId} 
      menuTitle='Department' 
      onDelete={onDeleteDepartment} 
      deleteContent={
        <Box mt={1}>
          <DeleteModalContent label="Name" value={name || NOT_APPLICABLE} />
          <DeleteModalContent label="Description" value={description || NOT_APPLICABLE} />
        </Box>
      }
      deleting={deleting}
      modal={
        <DepartmentModal department={department} refetch={refetch} />
      }
    />
  )
}

export default DepartmentMenu